module.exports = __webpack_public_path__ + "img/partner6.4d3fdfb6.png";